import React from 'react'
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import Electrical1 from '../img/Electrical/Electrical 1.jpg'
import Electrical2 from '../img/Electrical/Electrical 2.jpg'
import Electrical3 from '../img/Electrical/Electrical 3.jpg'
import {AnimationOnScroll} from 'react-animation-on-scroll'


function Electrical() {
  const location = useLocation();
  const componentRef = useRef(null);

  useEffect(() => {
      if (componentRef.current) {
          setTimeout(() => {

              componentRef.current.scrollIntoView({ behavior: "smooth" });
          }, 3000);
      }
  }, [location])
  return (
    
    <section ref={componentRef}>
      <div className="about">
            <h2 id="Content">Electrical Drawing</h2>
        </div>
        <div className="DispalyingImage">
          <AnimationOnScroll animateIn='slipeLeft'><img src={Electrical1} alt="" className="DisImg"/></AnimationOnScroll>
          <AnimationOnScroll animateIn='slipeLeft'><img src={Electrical2} alt="" className="DisImg"/></AnimationOnScroll>
          <AnimationOnScroll animateIn='slipeLeft'><img src={Electrical3} alt="" className="DisImg"/></AnimationOnScroll>
        </div>
    </section>
  )
}

export default Electrical
